import Flickity from "flickity";

class ProductItem {
	constructor(config) {
		this.config = Object.assign({
			scope: '[data-product-slider="scope"]',
			prev: '[data-product-slider="prev"]',
			next: '[data-product-slider="next"]',
			current: '[data-product-slider="current"]',
		}, config);

		this.$scope = $(this.config.scope);

		if(this.$scope.length > 0) {
			this.init();
		}
	}

	init() {
		this.addEventListeners();
	}

	addEventListeners() {
		this.$scope.each((index, scope) => {
			let $scope = $(scope);
			let slider = Flickity.data($scope.find('.flickity-carousel')[0]);
			slider.on('change', () => this.setPageInfo($scope, slider));
		});

		$(document).off('.product-slider')
			.on('click.product-slider', this.config.prev, this.slide.bind(this, 'prev'))
			.on('click.product-slider', this.config.next, this.slide.bind(this, 'next'))
	}

	slide(direction, event) {
		event.preventDefault();
		let $button = $(event.currentTarget);
		let $scope = $button.closest(this.config.scope);
		let slider = Flickity.data($scope.find('.flickity-carousel')[0]);

		if(direction === 'prev') {
			slider.previous();
		} else {
			slider.next();
		}
	}

	setPageInfo($scope, slider) {
		$scope.find(this.config.current).html(slider.selectedIndex + 1);
	}
}

export default new ProductItem;